import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-close\">\n<path d=\"M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z\" fill=\"#9D9D9D\" />\n<path d=\"M5.98542 6.35254H7.54083L9.22753 8.42572L10.9894 6.35254H12.4485L9.98883 9.17748L12.6232 12.2258H11.0349L9.18624 9.98007L7.29942 12.2258H5.80859L8.44612 9.17748L5.98542 6.35254Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol